export const ROUTES = {
  COMMON: {
    404: '/404error',
    HOMEPAGE: '/',
    HELP: 'https://app.gmoask.com/help',
    INFO: 'https://gmoask.jp/news/',
    FORBIDDEN_TEXT: 'https://app.gmoask.com/help#cp_tabfour056',
    ASK_POLICY: 'https://gmoask.jp/wp-content/uploads/2024/04/agreement.pdf',
    GGL_QUESTION_NUM: 'https://app.gmoask.com/help#cp_tabfour057',
    WITHDRAW_INQUIRY: 'https://app.gmoask.com/inquiry?from=/withdraw',
    GMO_RESEARCH_TOP: 'https://gmo-research.ai/',
    BEGINNER_GUIDE_VIDEO: 'https://www.youtube.com/watch?v=FYHUtm3jEBQ',
    ASK_NG_CHECKLIST: 'https://gmoask.jp/wp-content/uploads/2023/01/Questionnaire_Checklists.pdf',
  },
  USER: {
    SIGNUP: '/signup',
    SIGNUP_CONFIRM: '/signup/confirm',
    SIGNUP_COMPLETED: '/signup/completed',
    SIGNUP_VERIFY_COMPLETED: '/signup/verify_completed',
    SIGNIN: '/signin',
    MYPAGE: '/mypage',
    SURVEY_REGISTER_TYPE_SELECTION: '/survey/register/survey_type_selection',
    SURVEY_REGISTER_GOOGLE_FORMS: '/survey/register/google_forms',
    SURVEY_REGISTER_ORIGINAL_FORM: '/survey/register/original_form/methods',
    SURVEY_REGISTER_ORIGINAL_FORM_MANUAL: '/survey/register/original_form/manual/:id',
    SURVEY: '/survey/:id',
    SURVEY_APPLY: '/survey/:id/apply',
    SURVEY_APPLY_COMPLETED: '/survey/:id/apply/completed',
    SURVEY_REAPPLY_COMPLETED: '/survey/:id/apply/reapply_completed',
    EPSILON_RESULT: '/epsilon/result',
    PASSWORD_RESET_REQUEST: '/password_reset/request',
    PASSWORD_RESET_SEND_MAIL_COMPLETED: '/password_reset/send_mail_completed',
    PASSWORD_RESET_INPUT: '/password_reset/input',
    PASSWORD_RESET_COMPLETED: '/password_reset/completed',
    WEB_AGGREGATION: '/survey/register/gmoask_survey/aggregation/:surveyId',
    WITHDRAW: '/withdraw',
    WITHDRAW_CONFIRM: '/withdraw/confirm',
    WITHDRAW_COMPLETED: '/withdraw/completed',
    SIGNUP_ERROR: '/user/signup_error',
    403: '/user/403error',
    404: '/user/404error',
    500: '/user/500error',
    INQUIRY: '/inquiry',
  },
  ADMIN: {
    SIGNUP: '/admin/signup',
    SIGNUP_CONFIRM: '/admin/signup/confirm',
    SIGNUP_COMPLETED: '/admin/signup/completed',
    SIGNUP_VERIFY_COMPLETED: '/admin/signup/verify_completed',
    SIGNIN: '/admin/signin',
    MYPAGE: '/admin/mypage',
    SURVEY: '/admin/survey/:id',
    USERS: '/admin/users',
    ADMINISTRATORS: '/admin/administrators',
    PASSWORD_RESET_REQUEST: '/admin/password_reset/request',
    PASSWORD_RESET_SEND_MAIL_COMPLETED: '/admin/password_reset/send_mail_completed',
    PASSWORD_RESET_INPUT: '/admin/password_reset/input',
    PASSWORD_RESET_COMPLETED: '/admin/password_reset/completed',
    403: '/admin/403error',
    404: '/admin/404error',
    500: '/admin/500error',
  },
};

export const ADMIN_PATH_INDICATOR = 'admin';
